import { render, staticRenderFns } from "./Chamador.vue?vue&type=template&id=e21a643c&scoped=true&"
import script from "./Chamador.vue?vue&type=script&lang=js&"
export * from "./Chamador.vue?vue&type=script&lang=js&"
import style0 from "./Chamador.vue?vue&type=style&index=0&id=e21a643c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21a643c",
  null
  
)

export default component.exports